<template>
	<div class="houTai-modul">
		<div class="leftNavbg"></div>
		<Header></Header>

		<div class="leftNav">
			<!-- default-active="2" 默认打开  @open="handleOpen"
               @close="handleClose" -->
			<div class="home" @click="getHome">驾驶舱</div>
			<el-menu
					 class="el-menu-vertical-demo"
					 :default-active="firstPath"
					 unique-opened
					 :collapse="false"
					 :collapse-transition="true"
					 text-color="#fff"
					 background-color="rgba(0,0,0,0)"
					 style="height: 100%;"
					 active-text-color="#02B1F3">
				<el-submenu v-for="(item, num) in NavData" :key="num" :index="num.toString()">
					<template slot="title">
						<!-- <i :class="item.classIcon"></i> -->
						<div class="title-show">
							<img class="title-img" :src="item.icon" alt="" />
							<div slot="title">{{ item.menuName }}</div>
						</div>
					</template>
					<el-menu-item-group>
						<!-- :index="`${num+num1}`" -->
						<el-menu-item v-for="(item1, num1) in item.childMenu" @click="navBtn(item1)" :key="num1"
									  :disabled="item1.disabled" :index="item1.route">
							{{ item1.menuName }}
						</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
			</el-menu>
		</div>
		<div class="content">
			<keep-alive><router-view></router-view></keep-alive>
		</div>
	</div>
</template>

<script>
import Header from '@/views/components/new/Header.vue';
import { mapGetters, mapState } from 'vuex';
export default {
	name: 'ZuijiBridegIndex',

	data() {
		return {
			firstPath: '',
			NavData: []
		};
	},
	components: {
		Header
	},
	watch: {},
	computed: {
		// NavData () {
		//   let dataV = null;
		//   this.$store.state.menus.map(item => {
		//     dataV.push(
		//       {
		//         ...item,
		//         icon: require(`../../assets/image/${item.icon
		//           }.png`)
		//       }
		//     )
		//   })
		// }
	},
	mounted() {
		this.NavData = this.$store.state.menus;
		console.log(this.NavData);
		// this.searchClick();
		// console.log(this.$route);
		this.firstPath = this.$route.path;
		// console.log(this.firstPath);
	},
	created() { },
	methods: {
		// handleOpen (key, keyPath) {
		//   console.log(key, keyPath);
		// },
		// handleClose (key, keyPath) {
		//   console.log(key, keyPath);
		// },
		navBtn(item) {
			let path = item.route;
			this.firstPath = path;
			// console.log(item);
			this.$router.push(path); //在选中方法中编写path跳转代码
		},

		//跳转首页
		getHome() {
			this.$router.push("/layout");
		},

		async searchClick() {
			const res = await this.$api.sendPost('/menu/list', {});
			if (res.errcode == 0) {
				console.log('caidan>>>', res.data.voList);
				this.NavData = res.data.voList;
				res.data.voList.map(item => {
					item.icon = require(`../../assets/image/${item.icon}.png`);
				});
			} else {
				this.$message.warning(res.errmsg);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.houTai-modul {
	width: 100vw;
	height: 100vh;
	display: flex;
	background: #01357d;
	padding-top: 100px;
	box-sizing: border-box;

	.leftNavbg {
		width: 250px;
		position: absolute;
		left: 0;
		background: #0c132f;
		height: 100%;
		top: 0;
	}

	.home {
		width: 92px;
		height: 36px;
		background: #4078ff;
		opacity: 1;
		border-radius: 18px;
		color: #fff;
		text-align: center;
		font-size: 12px;
		line-height: 36px;
		margin: 0 auto 20px;
		cursor: pointer;
	}

	.leftNav {
		width: 250px;
		height: 100%;
		position: relative;
		z-index: 99;
	}

	.content {
		position: relative;
		z-index: 99;
		width: calc(100% - 300px);
		margin: 30px auto;
		background: #ffffff;
		box-shadow: 0px 8px 20px 0px rgba(0, 7, 26, 0.2);
		border-radius: 4px;
	}
}

.title-show {
	display: flex;
	align-items: center;

	.title-img {
		margin-right: 10px;
		width: 20px;
		height: 20px;
	}
}

/deep/.el-menu {
	border-right: none;
}

/deep/.el-menu-item {
	font-size: 16px;
	// color: #4e94a6 !important;
	// background: #10454f !important;
	color: #fff !important;
	background: #090c19 !important;
}

/deep/.el-submenu__title {
	font-size: 18px;
	text-align: left;
}

/deep/.el-menu .el-menu-item:hover {
	outline: 0 !important;
	// background: linear-gradient(270deg, #223a74 0%, #223a74 100%) !important;
	background: rgba(255, 255, 255, .2) !important;
}

/deep/.el-menu .el-menu-item.is-active {
	color: #17e5de !important;
	// background: linear-gradient(270deg, #223a74 0%, #223a74 100%) !important;
	// background: #1b7f91 !important;
	background: linear-gradient(270deg, rgba(64, 120, 250, 0.5) 0%, rgba(9, 12, 25, 0.5) 100%) !important;
}

.el-submenu /deep/.el-submenu__title:hover {
	color: #fff !important;
	// background: linear-gradient(270deg, #223a74 0%, #223a74 100%) !important;
	background: rgba(255, 255, 255, .2) !important;
}

/deep/.el-menu-item-group {
	text-align: left;
}</style>
